import { DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class DateService {
    constructor(private datePipe: DatePipe) {}

    static readonly FORMAT_DDMMYYYY: string = 'dd.MM.yyyy';
    static readonly FORMAT_MMDDYYYY: string = 'MM.dd.yyyy';

    static readonly FORMAT_DDMMYYYY_HHMMSS: string = 'dd.MM.yyyy HH:mm:ss';
    static readonly FORMAT_MMDDYYYY_HHMMSS: string = 'MM.dd.yyyy HH:mm:ss';

    static getDateFormat(lang: string) {
        switch (lang) {
            case 'DE':
                return this.FORMAT_DDMMYYYY;
            default:
                return this.FORMAT_MMDDYYYY;
        }
    }

    static getDateTimeFormat(lang: string) {
        switch (lang) {
            case 'DE':
                return this.FORMAT_DDMMYYYY_HHMMSS;
            default:
                return this.FORMAT_MMDDYYYY_HHMMSS;
        }
    }

    static getDefaultMinDateFromToday(): Date {
        return new Date(new Date().setDate(new Date().getDate() - 1));
    }

    static getDefaultMaxDateFromToday(): Date {
        var today = new Date();
        var defaultMaxYear = today.getFullYear() + 3;
        var defaultMaxMonth = today.getMonth();
        var defaultMaxDay = today.getDate();
        return new Date(defaultMaxYear, defaultMaxMonth, defaultMaxDay);
    }

    static getNow(): Date {
        return new Date();
    }

    static getTomorrow(): Date {
        return new Date(new Date().setDate(new Date().getDate() + 1));
    }

    static getDayAfterTomorrow(): Date {
        return new Date(new Date().setDate(new Date().getDate() + 2));
    }

    static convertTimestampToDate(timestamp: number | null | undefined): Date | undefined {
        return timestamp ? new Date(timestamp) : undefined;
    }

    static daysSince(date: number | Date | null | undefined): number {
        if (!date) return -1;
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const targetDate = new Date(date);
        targetDate.setHours(0, 0, 0, 0);
        return Math.floor((today.getTime() - targetDate.getTime()) / (1000 * 60 * 60 * 24));
    }

    static isDateInFuture(date: number | Date | null | undefined): boolean {
        if (!date) return false;
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const targetDate = new Date(date);
        targetDate.setHours(0, 0, 0, 0);
        return targetDate > today;
    }

    formatDateTime(timestamp: number | Date, language?: string): string | null {
        return this.datePipe.transform(timestamp, DateService.getDateTimeFormat(language ?? 'EN'));
    }

    formatDate(timestamp: number | Date, language?: string): string | null {
        return this.datePipe.transform(timestamp, DateService.getDateFormat(language ?? 'EN'));
    }
}
